export const CTA = {
  FOLLOW: 'follow',
  SUBSCRIBE: 'subscribe',
  REQUEST_SHOUTOUT: 'requestShoutout',
  SEND_SHOUTOUT: 'sendShoutout',
  FACE2FACE: 'face2face',
  AD_PLAYAZ: 'adPlayaz'
};

// `source` value sent to /shoutouts/create from the CTA share-link flow —
// the backend auto-follows the target team only for this source
export const SHOUTOUT_SOURCE_CTA = 'ctaShoutout';

export const ACTION_TYPES = {
  FOLLOW_UNFOLLOW: 'FOLLOW_UNFOLLOW',
  SUBSCRIBE_UNSUBSCRIBE: 'SUBSCRIBE_UNSUBSCRIBE',
  FACE2FACE: 'FACE2FACE',
  SHOUTOUT: 'SHOUTOUT',
  AD_PLAYAZ: 'AD_PLAYAZ'
};
